'use strict';

export default
{
  form:
  {
    formInputLabel:
    {
      color: '#235373'
    },
    title:
    {
      color: '#373660',
    },
    description:
    {
      color: '#909EAD',
    },
    popupDialog:
    {
      question:
      {
        color: '#575757'
      },
      okayBtn:
      {
        color: '#235373'
      }
    },
    submitBtn:
    {
      color: '#70a040'
    }
  },
  posts:
  {
    create:
    {
      title:
      {
        color: '#235373'
      },
      backgroundAccent:
      {
        color: '#E47725'
      }
    },
    post:
    {
      actions:
      {
        background:
        {
          color: '#f1f1f2'
        },
        like:
        {
          inactive:
          {
            primary:
            {
              color: '#225373'
            },
            secondary:
            {
              color:'#FFFFFF'
            }
          },
          active:
          {
            primary:
            {
              color: '#70a040'
            },
            secondary:
            {
              color:'#FFFFFF'
            }
          }
        }
      },
      comments:
      {
        sendButton:
        {
          background:
          {
            color: '#225373'
          },
          text:
          {
            color: '#FFFFFF'
          }
        }
      }
    }
  },
  settings:
  {
    closeButton:
    {
      color: '#9e9e9e'
    },
    toggleButton:
    {
      color: '#70a040'
    },
    checkbox:
    {
      color: '#70a040'
    }
  },
  gradient:
  {
    primary: 'gradient-primary',
    warning: 'gradient-warning',
    info: 'gradient-info',
    dark: 'gradient-dark',
    dange: 'gradient-danger',
    success: 'gradient-success',
  },
  search:
  {
    background: '#3c4b64',
    text: '#FFF', // Doesn't work, must be hard coded into component for some reason 
  }
};
